<div class="modal-header">
    <h2 class="modal-title">{{'invoice.filterPopup.title' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeHandler()">
    </button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-6 mb-3 mb-lg-0">
            <label class="label-input">
                {{'invoice.filterPopup.fromDate' | translate}}
            </label>
            <kendo-datepicker HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [(ngModel)]="startDate" 
                #startDateInput 
                [disabledDates]="disableStartDates"
                (click)="!startDateInput.isOpen ? startDateInput.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                >
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
        <div class="col-md-6">
            <label class="label-input">
                {{'invoice.filterPopup.toDate' | translate}}
            </label>
            <kendo-datepicker HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [(ngModel)]="endDate" 
                #endDateInput 
                [disabledDates]="disableEndDates"
                (click)="!endDateInput.isOpen ? endDateInput.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                >
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="resetHandler()">
        <i class="app-icon icon icon-reload icon-lg me-2"></i> 
        {{'invoice.filterPopup.reset' | translate}}
    </button>
    <button class="btn primary-btn" (click)="applyHandler()">
        {{'invoice.filterPopup.apply' | translate}}
    </button>
</div>